import { CmsItemSummary } from "../../common/scaffolding/types";

export const sortByDisplayName = <T extends CmsItemSummary>(a: T, b: T): number =>
    a.displayName.localeCompare(b.displayName);
